import React, { useEffect, useState } from 'react'
import { Input, Empty } from 'antd'
import './index.scss'
import PaymentService from '../../../../services/paymentService'
import { useAppParamsContext } from '../../../../context/AppParamsContext'
import { checkShowPaymentMethodWithTheme } from '../../../../components/PaymentMethodSelection/PaymentMethodSelection'
import { number_to_price } from '../../../../helper/common'
import { LoadingOutlined } from '@ant-design/icons'

export default function AutoTrafficFinePayment({
  promotionCode,
  paymentMethod,
  setPaymentMethod,
  isLoadingPromotionCode,
  errorPromotionCode,
  calculatePaymentWithPromotion,
  handleChangePromotionCode,
  paymentCalculated
}) {
  const { paymentMethodType } = useAppParamsContext()
  const [listPaymentMethod, setListPaymentMethod] = useState([])

  const fetchPaymentMethods = async () => {
    const response = await PaymentService.getPaymentQRMethod({})
    if (response && typeof response === 'object') {
      const paymentMethodFromSession = paymentMethodType
      let filteredData = Object.values(response)
      if (paymentMethodFromSession && paymentMethodFromSession !== undefined && paymentMethodFromSession !== null) {
        filteredData = filteredData.filter((item) => item.paymentMethodType === paymentMethodFromSession)
      } else {
        // Phần này sẽ check hiển thị theo đúng theme (phân sách SMoc và TAMove)
        filteredData = checkShowPaymentMethodWithTheme(filteredData)
      }
      const dataConverted = Object.fromEntries(
        filteredData.map((item) => {
          return [item.paymentMethodId, item]
        })
      )
      setPaymentMethod(Object.values(dataConverted || {})?.[0])
      setListPaymentMethod(dataConverted)
    }
  }

  useEffect(() => {
    fetchPaymentMethods()
  }, [])

  return (
    <div className="autoTrafficFinePayment">
      {/* Discount Section */}
      {/* <div>
        <div className="section-title">Mã Giảm Giá</div>
        <div className="d-flex">
          <Input
            value={promotionCode}
            onChange={handleChangePromotionCode}
            placeholder="Nhập mã giảm giá!"
            style={{ height: 46, borderTopLeftRadius: 8, borderBottomLeftRadius: 8, borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
            onBlur={(e)=>{
              if (!e.target.value && (paymentCalculated?.discountAmount > 0)) {
                 calculatePaymentWithPromotion(true)
              }
            }}
          />
          <BaseButton
            style={{ width: '25%', borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
            className={`${!promotionCode || isLoadingPromotionCode ? 'disabled' : ''}`}
            onClick={() => {
              calculatePaymentWithPromotion()
            }}
            disabled={!promotionCode || isLoadingPromotionCode}>
            {isLoadingPromotionCode ? <LoadingOutlined /> : 'Áp dụng'}
          </BaseButton>
        </div>
        {errorPromotionCode && (
          <div className="text-danger mt-1" style={{ fontSize: 14, lineHeight: 1.5, fontWeight: 400 }}>
            {errorPromotionCode}
          </div>
        ) }
          {
            (paymentCalculated?.discountAmount || 0) > 0 && (
              <div className="text-primary mt-1" style={{ fontSize: 14, lineHeight: 1.5, fontWeight: 400 }}>
                Mã giảm giá: - {number_to_price(paymentCalculated?.discountAmount || 0)}đ ({paymentCalculated?.promotionData?.promotionCode})
              </div>
            )
          }

      </div> */}

      {/* Payment Method Section */}

      <div className="autoTrafficFinePayment_paymentMethodSection">
        <div style={{ fontWeight: 600, fontFamily: 'Roboto, sans-serif', fontSize: 20, lineHeight: '28px', color: 'rgba(0, 0, 0, 0.85)' }}>
          Phương Thức Thanh Toán
        </div>
        <div style={{ fontSize: 14, lineHeight: 1.5, fontWeight: 400, color: 'var(--text-secondary)' }}>Vui lòng chọn 1 hình thức</div>
        {Object.keys(listPaymentMethod)?.length > 0 ? (
          <div className="payment-method-grid">
            {Object.keys(listPaymentMethod).map((key) => {
              const method = listPaymentMethod[key]
              return (
                <div
                  key={key}
                  onClick={() => setPaymentMethod(method)}
                  className={`payment-method-item ${+paymentMethod?.paymentMethodId === +key ? 'active' : ''} ${
                    Object.values(listPaymentMethod)?.length === 1 && 'w-100'
                  }`}>
                  <img height={30} src={method?.paymentMethodImageUrl} alt={method?.paymentMethodReferName} style={{ marginBottom: '8px' }} />
                  <div className="payment-method-name">{method.paymentMethodName || key}</div>
                </div>
              )
            })}
          </div>
        ) : (
          <Empty description="Không có phương thức thanh toán" />
        )}
      </div>
    </div>
  )
}
